var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('atom-text',{staticStyle:{"font-weight":"600","text-align":"center"},attrs:{"size":"x-large","color":_vm.color,"text":_vm.title}})}
var staticRenderFns = []

export { render, staticRenderFns }